var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlloy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.93,56.44H21.07a5.54,5.54,0,0,1-4.77-2.75L5.37,34.75a5.51,5.51,0,0,1,0-5.5L16.3,10.31a5.54,5.54,0,0,1,4.77-2.75H42.93a5.54,5.54,0,0,1,4.77,2.75L58.63,29.25a5.51,5.51,0,0,1,0,5.5L47.7,53.69A5.54,5.54,0,0,1,42.93,56.44ZM21.07,10.56a2.52,2.52,0,0,0-2.17,1.25L8,30.75a2.48,2.48,0,0,0,0,2.5L18.9,52.19a2.52,2.52,0,0,0,2.17,1.25H42.93a2.52,2.52,0,0,0,2.17-1.25L56,33.25a2.48,2.48,0,0,0,0-2.5L45.1,11.81a2.52,2.52,0,0,0-2.17-1.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32,42.07A10.07,10.07,0,1,1,42.07,32,10.08,10.08,0,0,1,32,42.07Zm0-17.14A7.07,7.07,0,1,0,39.07,32,7.08,7.08,0,0,0,32,24.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlloy);
export default __webpack_public_path__ + "static/media/alloy.d48b19e73ca1e2953d3d0f4fa09ba07b.svg";
export { ForwardRef as ReactComponent };